import { cssRaw, cssRule } from "typestyle";
import colors from "./colors";
import "./inter.css";

export const injectGlobals = () => {
  cssRule("*", {
    boxSizing: "border-box",
    fontFamily: "Inter, sans-serif",
    $nest: {
      "@supports (font-variation-settings: normal)": {
        fontFamily: '"InterVariable", sans-serif',
      },
    },
  });

  cssRule("input", {
    fontFamily: "Inter, sans-serif",
    $nest: {
      "@supports (font-variation-settings: normal)": {
        fontFamily: '"InterVariable", sans-serif',
      },
    },
  });

  cssRule("html, body", {
    height: "100%",
    backgroundColor: "#F8F8F8",
    color: colors.grey[900],
    lineHeight: "1.4",
  });

  cssRule("body", {
    display: "flex",
    flexDirection: "column",
  });

  cssRule("#root", {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  });

  cssRule("img", {
    display: "block",
  });

  cssRaw("* { -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale; }");

  cssRule("a", {
    color: colors.grey[700],
    textDecoration: "none",

    $nest: {
      "&:hover": {
        textDecoration: "underline",
        color: colors.grey[900],
      },
    },
  });
};

export const unit = (n: number): string => `${n * 4}px`;
